import { mapGetters } from "vuex"
export default {
  data() {
    return {
      civilite: "",
      nom: "",
      prenom: "",
      anneeNaissance: undefined,
      courriel: "",
      anneesDeNaissance: []
    }
  },
  methods: {
    fillInfosPersonnellesFromStore() {
      this.civilite = this.account.civilite.id
      this.nom = this.account.nom
      this.prenom = this.account.prenom
      this.courriel = this.account.courriel
      this.anneeNaissance = this.account.anneeNaissance
    },
    emptyInfosPersonnellesValues() {
      this.civilite = ""
      this.nom = ""
      this.prenom = ""
      this.anneeNaissance = undefined
      this.courriel = ""
    }
  },
  mounted() {

    for (let year = new Date().getFullYear() - 16; year > new Date().getFullYear() - 110; year--) {
      this.anneesDeNaissance.push({ text: year, value: year })
    }

    if (this.loggedIn) {
      this.fillInfosPersonnellesFromStore()
    }
  },
  computed: {
    ...mapGetters(["account", "loggedIn"])
  },
  watch: {
    loggedIn(newVal) {
      if (newVal) {
        this.fillInfosPersonnellesFromStore()
      } else {
        this.emptyInfosPersonnellesValues()
      }
    }
  }

}